"use client";

import { useLocale } from "@i18n/react";
import { useQueryClient } from "@tanstack/react-query";

import { useRequestMutation } from "../../../../../request/hooks/useRequestMutation";
import { useRequestQuery } from "../../../../../request/hooks/useRequestQuery";
import { keyUsersMeSettings } from "./keyUsersMeSettings";
import { usersMeSettingsSchema } from "./schema/usersMeSettingsSchema";

type UsersMeSettingsMutationPutData = {
  settings: {
    key: "is_post_prayer_streak_enabled";
    scope: "global" | "per_community" | "per_device" | "per_user";
    value: string;
  }[];
};

export const useRequestUsersMeSettings = () => {
  const locale = useLocale();
  const queryClient = useQueryClient();

  return {
    mutationPut: useRequestMutation({
      mutationFnRequestProps: (data: UsersMeSettingsMutationPutData) => ({
        body: JSON.stringify(data),
        method: "PUT",
        urlBackendPath: "/users/me/settings",
      }),
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: [keyUsersMeSettings(), locale],
        }),
    }),
    query: useRequestQuery({
      queryFnRequestProps: {
        schema: usersMeSettingsSchema,
        urlBackendPath: "/users/me/settings",
      },
      queryKey: keyUsersMeSettings(),
    }),
  };
};
